module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(this.status == 1) ? _c('span', {
    staticClass: "badge badge-gray"
  }, [_vm._v("Szkic")]) : _vm._e(), _vm._v(" "), (this.status == 2) ? _c('span', {
    staticClass: "badge badge-alert"
  }, [_vm._v("Przeznaczona do wysłania")]) : _vm._e(), _vm._v(" "), (this.status == 3) ? _c('span', {
    staticClass: "badge badge-alert"
  }, [_vm._v("W trakcie wysyłania")]) : _vm._e(), _vm._v(" "), (this.status == 4) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v("Wysłana")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-215a5492","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messages/MessageStatus.vue
// module id = 232
// module chunks = 0